import styled, { css } from 'styled-components';

export const linkStyle = css`
  color: #2f3034;
  text-decoration: none;
  line-height: 1.9;
  &:hover {
    opacity: 0.8;
  }
`;

export const DropdownLink = styled.a<{ isFooter?: Boolean }>`
  display: block;
  ${linkStyle};
  ${props =>
    props.isFooter
      ? css`
          text-align: center;
          width: 100%;
        `
      : false}
`;

export const DropdownRow = styled.div<{ hasBreak?: Boolean }>`
  padding: 10px 20px;
  ${props =>
    props.hasBreak
      ? css`
          position: relative;
          &::before {
            content: ' ';
            display: block;
            position: absolute;
            top: 0;
            left: 10px;
            background: #ddd;
            height: 1px;
            width: calc(100% - 20px);
          }
        `
      : false};
`;
